export default __webpack_public_path__ + "static/media/blast.d3fa909b.png";